import React, { useEffect, useState } from "react";
import SubScreenHeading from "../../components/CustomComponents/ScreenHeader";
import AppleStoreIcon from "../../assets/theme/images/apple-store-icon.svg";
import PlayStoreIcon from "../../assets/theme/images/play-store-icon.svg";
import PinataHandMobile from "../../assets/theme/images/pinata-hand-mobile.png";
import { useNavigate } from "react-router-dom";
import { UserService } from "../../services/userServices";
import { getLocalStorage, setLocalStorage } from "../../utils/localStorage";
import { LOCAL_STORAGE } from "../../utils/constants";
import LogoPinyadaColor from "../../assets/theme/images/logo-pinyada-color.png";
import UserProfileIcon from "../../assets/Icons/header/user.png";
import PreviewImg from "../../assets/theme/images/about-us-preview.png";
// import aboutVideo from "../../assets/theme/video/PinyadaOveriewbyMidwesternLesbian.mp4"; // adjust path
export default function About() {
  const navigate = useNavigate();
  const userId = getLocalStorage(LOCAL_STORAGE.USER_ID);
  const [userDetails, setUserDetails] = useState<any>("");
  const [play, setPlay] = useState(false);

  useEffect(() => {
    if (userId) {
      getUserProfileDetails();
    }
  }, []);

  const getUserProfileDetails = async () => {
    try {
      const res = await UserService.getUserProfileDetails();
      if (res?.data) {
        setLocalStorage(LOCAL_STORAGE.PROFILE_STATUS, res?.data?.profileStatus);
        setUserDetails(res?.data);
      }
    } catch (error: any) {
      console.log(
        "error getGuestEventDtls : ",
        error?.response?.data?.error || error?.message
      );
    }
  };

  return (
    <section className="w-full min-h-screen flex flex-col ">
      {/* Header: Logo and Actions */}
      <header className="w-full px-3 md:px-7 lg:px-6 xl:px-8 py-4 flex items-center justify-between  z-20">
        <div className="bg-white/70 backdrop-blur-sm px-3 py-1.5 md:px-4 md:py-2 rounded-lg shadow-md flex items-center space-x-3">
          <img
            src={LogoPinyadaColor}
            alt="Pinyada Logo"
            className="w-[8rem] h-auto md:w-[10rem] md:h-auto"
            onClick={() => navigate("/")}
          />
        </div>

        <div className="flex items-center justify-between gap-2">
          <div
            className="flex gap-2 items-center text-md font-semibold rounded-md bg-white/70 backdrop-blur-sm px-3 py-1.5 md:px-4 md:py-2 cursor-pointer border-1 border-black text-black hover:scale-105 transform transition-all duration-200"
            onClick={() => navigate("/help/faq")}
          >
            FAQ
          </div>
          {userId ? (
            <div className="flex items-center bg-white rounded-full shadow-lg px-1.5 py-1.5 hover:scale-105 transform transition-all duration-200">
              <div
                className="flex gap-2 cursor-pointer items-center relative z-20 rounded-full"
                onClick={() => navigate("/discover")}
              >
                <img
                  src={userDetails?.profilePhoto || UserProfileIcon}
                  className="h-7 w-7 md:h-8 md:w-8 rounded-full object-cover"
                  alt="Profile"
                />
              </div>
            </div>
          ) : (
            <div
              className="flex gap-2 items-center text-md font-semibold rounded-md bg-black text-white px-3 py-1.5 md:px-4 md:py-2 cursor-pointer border-1 border-white hover:scale-105 transform transition-all duration-200"
              onClick={() => navigate("/auth")}
            >
              Login
            </div>
          )}
        </div>
      </header>

      {/* Content Area */}
      <main className="flex flex-1 w-full flex-col md:flex-row overflow-hidden">
        <div className="w-full md:w-1/2 flex items-center justify-start p-1 px-3 md:px-8">
          <div className="w-full">
            <SubScreenHeading
              text="ABOUT"
              customClass="text-black text-[20px] md:text-[32px] font-bold"
            />

            <div className="mt-6 text-left font-[PINYADA-SpaceGrotesk-Regular] text-[#333] text-base md:text-lg max-w-xl">
              <p className="mb-6">
                Pinyada is an event management social platform that helps guests
                connect before and after events. We give hosts the tools to
                create more intentional gatherings, and we give guests a way to
                build real relationships around the events they attend — all
                with transparent ticketing fees of just 5% plus $1 per ticket.
              </p>

              <button
                onClick={() => navigate("/auth")}
                className="bg-black text-white px-6 py-3 rounded-full text-sm shadow-md hover:bg-gray-800"
              >
                Try it out →
              </button>

              <div className="mt-10">
                <h2 className="text-lg md:text-xl font-bold text-black mb-4">
                  Hear from an event host why Pinyada is the perfect choice for
                  connection-based events!
                </h2>

                {/* Responsive aspect-ratio video with preview */}
                <div className="w-full max-w-[640px] aspect-video bg-black rounded-xl overflow-hidden shadow-lg flex items-center justify-center">
                  <video
                    className="w-full h-full object-contain bg-black"
                    controls
                    poster={require("../../assets/theme/images/about-us-preview.png")}
                  >
                    <source
                      src="https://sondr-be-prod.s3.us-east-2.amazonaws.com/AboutUs/AboutUs.mp4"
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Panel */}
        <div className="hidden md:flex w-full md:w-1/2 fixed bottom-0 inset-y-0 right-0 flex flex-col justify-center bg-cover bg-center profile-right-panel">
          {/* <div className="w-4/5"> */}
          <div className="w-1/2 mt-1 mb-7 px-8 pt-1">
            <h2 className="text-3xl lg:text-4xl font-bold text-black text-left font-[PINYADA-Beranda-Regular] tracking-tighterCustom leading-tight-120 tracking-tight-2">
              DOWNLOAD THE PINYADA APP
            </h2>
          </div>
          <div className="flex gap-3 mt-4 mb-7 px-8 pt-2">
            <a
              href="https://apps.apple.com/app/id6444107828"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={AppleStoreIcon}
                alt="App Store"
                width={150}
                height={50}
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.app.socha&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={PlayStoreIcon}
                alt="Google Play"
                width={150}
                height={50}
              />
            </a>
          </div>
          <img
            src={PinataHandMobile}
            alt="Mobile App"
            className="w-64 md:w-80 lg:w-96 absolute bottom-0 right-3"
          />
        </div>
        {/* </div> */}
      </main>
    </section>
  );
}
